import { Injectable, OnInit, Output } from '@angular/core';
import { CITIES } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';


@Injectable()
export class UserService extends AuthService{

    private URLGetUser = "manager/user/:id";
    private URLGetUserAddress = "manager/user/:id/address";
    private URLGetFutureServices = "manager/user/:id/future-services";
    private URLGetHistoryServices = "manager/user/:id/past-services";
    private URLCreateAddress = "manager/user/:id/address";
    private URLUpdateAddress = "manager/user/:id/address/:idAddress";
    private URLFavCleaner = "manager/user/:id/fav/:idCleaner";
    private URLBlockCleaner = "manager/user/:id/block/:idCleaner";
    private URLLinkUpdateCard = "manager/user/:id/link-to-update-card";
    private URLSendMailBill = "api/v1/mails/send/";
    private URLgetClientInfo = "api/v1/getClientInfoUserArea/:id";
    private ID = ":id";
    private IDADDRESS = ":idAddress";
    private IDCLEANER = ":idCleaner";
    private MANDATE = ":mandate";
    public subjectOpenModal$
    public subjectCloseModal$;
    public subjectOpen = new Subject();
    public subjectClose = new Subject();
   
    constructor(public http: Http, public router: Router) { 
        super(http, router);
         this.subjectOpenModal$ = this.subjectOpen.asObservable();
         this.subjectCloseModal$ = this.subjectClose.asObservable();
    }

    public getAvailableCities() {
        return CITIES;
    }

    public getUserData(id: string){
        let URLGetUser = this.URLGetUser.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetUser ,{headers: this.headers})
        .map((res) => res.json()["response"])
        .filter(data => {
            if(data["contact_preference"] == 0){
                data["contact_preference"] = "Email";
            }else if(data["contact_preference"] == 1){
                data["contact_preference"] = "Télefono";
            }else if(data["contact_preference"] == 2) {
                data["contact_preference"] = "Whatsapp";
            }
            return true;
        })

    }

    public getFutureServices(id: string) {
        let URLGetFutureServices = this.URLGetFutureServices.replace(this.ID, id).replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetFutureServices, {headers: this.headers})
        .map((res: Response) => res.json()["response"])
        .filter(services => {
            services["today"].forEach(service => {
                service["date"] = moment(service["date"], "YYYY-MM-DD").format("DD/MM/YYYY");
            });
            services["future"].forEach(service => {
                service["date"] = moment(service["date"], "YYYY-MM-DD").format("DD/MM/YYYY");
            });
            return true;
        });
    }

    public getHistoryServices(id: string) {
        let URLGetHistoryServices = this.URLGetHistoryServices.replace(this.ID, id).replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetHistoryServices, {headers: this.headers})
        .map((res: Response) => res.json()["response"])
        .filter(services => {
            services.forEach(service => {
                service["date"] = moment(service["date"], "YYYY-MM-DD").format("DD/MM/YYYY");
            });
            return true;
        });
    }

    public getClientInfo(id: string, token: string) {
        let URLgetClientInfo = this.URLgetClientInfo.replace(this.ID, id);
        let headers = new Headers();
        headers.append("Content-type","application/json");
        headers.append("X-Access-Token",token);
        headers.append("X-Key","version1");
        return this.http.get(this.APIURL + URLgetClientInfo ,{headers: headers})
        .map((res) => res.json())
    }

    public loginApi() {
        let data = {
            username: "felipe@clintu.es",
            password: "pass123"
        }
        return this.http.post(this.APIURL + "login", data)
        .map((res) => res.json());
    }

    public createNewAddress(id: string, data: object) {
        let URLCreateAddress = this.URLCreateAddress.replace(this.ID, id);
        return this.http.post(this.APIURL + URLCreateAddress , data, {headers: this.headers})
        .map((res) => res.json()); 
    }

    public updateAddress(id: string, idAddress: string, data: object) {
        let URLUpdateAddress = this.URLUpdateAddress.replace(this.ID, id).replace(this.IDADDRESS, idAddress);
        return this.http.put(this.APIURL + URLUpdateAddress , data, {headers: this.headers})
        .map((res) => res.json());
    }

    public deleteAddress(id: string, idAddress: string) {
        let URLUpdateAddress = this.URLUpdateAddress.replace(this.ID, id).replace(this.IDADDRESS, idAddress);
        return this.http.delete(this.APIURL + URLUpdateAddress, {headers: this.headers})
        .map((res) => res.json());
    }

    public unFavCleaner(id: string, idCleaner: string) {
        let URLFavCleaner = this.URLFavCleaner.replace(this.ID, id).replace(this.IDCLEANER, idCleaner);
        return this.http.delete(this.APIURL + URLFavCleaner, {headers: this.headers})
        .map((res) => res.json());
    }

    public favCleaner(id: string, idCleaner: string) {
        let URLFavCleaner = this.URLFavCleaner.replace(this.ID, id).replace(this.IDCLEANER, idCleaner);
        return this.http.post(this.APIURL + URLFavCleaner, {}, {headers: this.headers})
        .map((res) => res.json());
    }

    public blockCleaner(id: string, idCleaner: string) {
        let URLBlockCleaner = this.URLBlockCleaner.replace(this.ID, id).replace(this.IDCLEANER, idCleaner);
        return this.http.post(this.APIURL + URLBlockCleaner, {}, {headers: this.headers})
        .map((res) => res.json());
    }

    public unBlockCleaner(id: string, idCleaner: string) {
        let URLBlockCleaner = this.URLBlockCleaner.replace(this.ID, id).replace(this.IDCLEANER, idCleaner);
        return this.http.delete(this.APIURL + URLBlockCleaner, {headers: this.headers})
        .map((res) => res.json());
    }

    public sendLinkUpdateCard(id: string) {
        let URLLinkUpdateCard = this.URLLinkUpdateCard.replace(this.ID, id).replace(this.ID, id);
        return this.http.get(this.APIURL + URLLinkUpdateCard, {headers: this.headers})
        .map((res) => res.json()["status"]);
    }

    public sendMailBill(data: object) {
        return this.http.post(this.APIURL + this.URLSendMailBill, data, {headers: this.headers})
        .map((res) => res.json()["status"]);
    }

    public showModalObservable(){
        return this.subjectOpenModal$;
    }

    public hideModalObservable(){
        return this.subjectCloseModal$;
    }

    public showModal(value){
        this.subjectOpen.next(value);
    }

    public hideModal(value) {
        this.subjectClose.next(value);
    }

}


// WEBPACK FOOTER //
// ./src/app/injections/user.service.ts